(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["casinetto-blog-article"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* Copy link button */
  document.querySelectorAll('.c-blog-article__share-copy').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var url = btn.dataset.copyUrl;
      var label = btn.querySelector('[data-copy-label]');
      if (!url || !label) return;
      var original = label.textContent;
      navigator.clipboard.writeText(url).then(function() {
        label.textContent = btn.closest('.c-blog-article').dataset.copiedText || 'Copied!';
        setTimeout(function() { label.textContent = original; }, 2000);
      });
    });
  });

  /* Reading progress bar + back to top */
  var bar = document.querySelector('[data-blog-progress]');
  var body = document.querySelector('.c-article-body');
  var backBtn = document.querySelector('[data-blog-back-top]');
  if (!bar || !body) return;

  var ticking = false;
  var heroFrame = document.querySelector('.c-blog-article__hero-frame');

  function update() {
    var rect = body.getBoundingClientRect();
    var viewH = window.innerHeight;
    var start = rect.top + window.scrollY;
    var end = start + rect.height;
    var scrollY = window.scrollY;

    /* Progress: 0 at body top, 1 at body bottom */
    var progress = Math.min(Math.max((scrollY - start + viewH * 0.3) / (end - start), 0), 1);
    bar.style.inlineSize = (progress * 100) + '%';

    /* Show bar after hero scrolls out */
    var heroBottom = heroFrame
      ? heroFrame.getBoundingClientRect().bottom
      : rect.top;
    if (heroBottom < 0) {
      bar.classList.add('c-blog-article__progress--visible');
    } else {
      bar.classList.remove('c-blog-article__progress--visible');
    }

    /* Fade bar at endpoints */
    if (progress <= 0 || progress >= 1) {
      bar.classList.remove('c-blog-article__progress--visible');
    }

    /* Back to top: show after scrolling past hero */
    if (backBtn) {
      if (scrollY > viewH * 1.5) {
        backBtn.hidden = false;
        requestAnimationFrame(function() {
          backBtn.classList.add('c-blog-article__back-top--visible');
        });
      } else {
        backBtn.classList.remove('c-blog-article__back-top--visible');
        backBtn.addEventListener('transitionend', function hide() {
          if (!backBtn.classList.contains('c-blog-article__back-top--visible')) {
            backBtn.hidden = true;
          }
          backBtn.removeEventListener('transitionend', hide);
        });
      }
    }

    ticking = false;
  }

  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  /* Back to top click */
  if (backBtn) {
    backBtn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* Initial check */
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casinetto-blog-index"] && !Shopify.designMode) return;
  try {
    
(function() {
  // This block compiles to a static asset that is never parsed as Liquid,
  // so the section id is read from the DOM rather than interpolated (B2C-293).
  document.querySelectorAll('[data-blog-index]').forEach(initLoadMore);

  function initLoadMore(section) {
    var grid = section.querySelector('[data-blog-grid]');
    var btn = section.querySelector('[data-blog-load-btn]');
    if (!grid || !btn) return;

    var totalPages = parseInt(section.dataset.totalPages, 10);
    var currentPage = parseInt(section.dataset.currentPage, 10);
    var sectionId = section.dataset.sectionId;
    var loading = false;

    btn.addEventListener('click', function() {
      if (loading || currentPage >= totalPages) return;
      loading = true;
      btn.disabled = true;

      var nextPage = currentPage + 1;
      var url = window.location.pathname + '?page=' + nextPage + '&section_id=' + sectionId;

      fetch(url)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var items = doc.querySelectorAll('[data-blog-grid] .c-blog-grid__item');
          items.forEach(function(item) {
            grid.appendChild(item);
          });
          currentPage = nextPage;
          section.dataset.currentPage = currentPage;
          if (currentPage >= totalPages) {
            btn.hidden = true;
          }
        })
        .catch(function(err) {
          console.error('Blog load-more error:', err);
        })
        .finally(function() {
          loading = false;
          btn.disabled = false;
        });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casinetto-cart-drawer"]) return;
  try {
    
  (function () {
    var wrapper = document.querySelector('[data-cart-drawer]');
    if (!wrapper) return;

    var sectionId = wrapper.dataset.sectionId;
    var panel = wrapper.querySelector('.c-cart-drawer__panel');
    var overlay = wrapper.querySelector('[data-cart-drawer-overlay]');
    var body = wrapper.querySelector('[data-cart-drawer-body]');
    var deliveryBar = wrapper.querySelector('[data-cart-drawer-delivery]');
    var countEl = wrapper.querySelector('[data-cart-drawer-count]');
    var subtotalEl = wrapper.querySelector('[data-cart-drawer-subtotal]');
    var checkoutBtn = wrapper.querySelector('[data-cart-drawer-checkout]');
    var checkoutNotice = wrapper.querySelector('[data-cart-drawer-checkout-notice]');
    var liveRegion = document.querySelector('[data-cart-drawer-live]');
    var cartTrigger = document.querySelector('[data-cart-drawer-trigger]');

    var isOpen = false;
    var isStale = true;

    /* ---- Trash icon SVG (injected at qty=1) ---- */
    var TRASH_SVG = '<span class="c-icon" style="width:14px;height:14px;" aria-hidden="true"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2"/><path d="M5 6v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6"/><path d="M10 11v6M14 11v6"/></svg></span>';
    var MINUS_SVG = '<span class="c-icon" style="width:14px;height:14px;" aria-hidden="true"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14"/></svg></span>';

    /* ---- Update dec button icon based on qty ---- */
    function updateDecButtons() {
      var steppers = body.querySelectorAll('.c-cart-drawer__stepper-wrap .c-qty');
      steppers.forEach(function (stepper) {
        var input = stepper.querySelector('input[type="number"]');
        var decBtn = stepper.querySelector('[data-qty-action="dec"]');
        if (!input || !decBtn) return;
        var qty = parseInt(input.value, 10) || 0;
        if (qty <= 1) {
          decBtn.innerHTML = TRASH_SVG;
          decBtn.classList.add('is-trash');
          decBtn.setAttribute('aria-label', 'Remove item');
        } else {
          decBtn.innerHTML = MINUS_SVG;
          decBtn.classList.remove('is-trash');
          decBtn.setAttribute('aria-label', 'Decrease quantity');
        }
      });
    }

    /* ---- Delivery countdown (engine-driven) ---- */
    var countdownTextEl = wrapper.querySelector('[data-drawer-countdown-text]');
    var countdownDotEl = wrapper.querySelector('[data-drawer-countdown-dot]');
    var deliveringToEl = wrapper.querySelector('[data-drawer-delivering-to]');
    var countdownRow = wrapper.querySelector('[data-countdown-opens-selector]');

    function applyPromise(p) {
      if (!countdownTextEl) return;

      countdownTextEl.textContent = p.countdown
        ? p.label + ' \u2014 order in ' + p.countdown
        : p.label;

      /* Dot color */
      if (countdownDotEl) {
        countdownDotEl.className = 'c-cart-drawer__countdown-dot';
        countdownDotEl.classList.add('c-cart-drawer__countdown-dot--' + p.dotColor);
        if (p.dotPulsing) {
          countdownDotEl.classList.add('c-cart-drawer__countdown-dot--pulse');
        } else {
          countdownDotEl.classList.add('c-cart-drawer__countdown-dot--no-pulse');
        }
      }

      /* Delivering-to line */
      if (deliveringToEl) {
        if (p.district && (p.type === 'same-day' || p.type === 'next-day' || p.type === 'future')) {
          deliveringToEl.textContent = 'Delivering to ' + p.district;
          deliveringToEl.removeAttribute('hidden');
        } else if (p.type === 'no-region') {
          deliveringToEl.textContent = 'Set your area for delivery times';
          deliveringToEl.removeAttribute('hidden');
        } else {
          deliveringToEl.setAttribute('hidden', '');
        }
      }
    }

    /* Register engine callback */
    function hookEngine() {
      if (window.CasinettoDelivery) {
        window.CasinettoDelivery.onUpdate(applyPromise);
        return;
      }
      document.addEventListener('delivery:ready', function () {
        window.CasinettoDelivery.onUpdate(applyPromise);
      });
    }
    hookEngine();

    /* Countdown row click → open region selector */
    if (countdownRow) {
      countdownRow.addEventListener('click', function () {
        if (window.CasinettoDelivery) {
          closeDrawer();
          setTimeout(function () { window.CasinettoDelivery.openSelector(); }, 350);
        }
      });
      countdownRow.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    }

    /* Delivering-to line click → open region selector */
    if (deliveringToEl) {
      deliveringToEl.addEventListener('click', function () {
        if (window.CasinettoDelivery) {
          closeDrawer();
          setTimeout(function () { window.CasinettoDelivery.openSelector(); }, 350);
        }
      });
    }

    /* ---- Swipe-to-dismiss (mobile) ---- */
    var touchStartY = 0;
    var touchDeltaY = 0;
    var isSwiping = false;

    function onTouchStart(e) {
      /* Only initiate swipe from header area or when scrolled to top */
      var scrollTop = body ? body.scrollTop : 0;
      var isHeader = e.target.closest('.c-cart-drawer__header');
      if (!isHeader && scrollTop > 0) return;
      touchStartY = e.touches[0].clientY;
      touchDeltaY = 0;
      isSwiping = true;
      panel.style.transition = 'none';
    }

    function onTouchMove(e) {
      if (!isSwiping) return;
      touchDeltaY = e.touches[0].clientY - touchStartY;
      if (touchDeltaY < 0) touchDeltaY = 0; /* Only downward */
      if (touchDeltaY > 10) {
        panel.style.transform = 'translateY(' + touchDeltaY + 'px)';
      }
    }

    function onTouchEnd() {
      if (!isSwiping) return;
      isSwiping = false;
      panel.style.transition = '';
      if (touchDeltaY > 100) {
        // Drop the drag's inline translateY so the CSS closed state takes over
        // and the panel slides on from where the finger left it. Left in place,
        // the inline value outranks translateY(100%): the panel stays put and
        // its transitionend (which sets `hidden`) never fires.
        panel.style.transform = '';
        closeDrawer();
      } else {
        panel.style.transform = '';
        /* Re-apply open state transform */
        if (isOpen) {
          panel.setAttribute('aria-hidden', 'false');
        }
      }
      touchDeltaY = 0;
    }

    /* Only enable swipe on mobile */
    function isMobile() {
      return window.innerWidth < 600;
    }

    // ---- Open ----
    function openDrawer() {
      if (isOpen) return;
      isOpen = true;

      // The read side of cart sync deliberately does not run on every page
      // load — the freshness requirement is web -> app, and app -> web has
      // none. So the drawer is one of the surfaces that has to ask: opening it
      // is the moment the shopper looks at the cart and it has to be right.
      // Fire and forget; the drawer renders from /cart.js and re-renders on the
      // cart:update the reconciliation emits.
      if (window.CasinettoCartSync && window.CasinettoCartSync.reconcile) {
        window.CasinettoCartSync.reconcile();
      }

      wrapper.classList.add('c-cart-drawer--open');
      panel.removeAttribute('hidden');

      // Trigger transition in next frame
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          panel.setAttribute('aria-hidden', 'false');
        });
      });

      // Lock body scroll
      document.documentElement.style.overflow = 'hidden';

      // Fetch fresh content
      if (isStale) {
        refreshDrawer();
      }

      // Update trash/minus icons
      updateDecButtons();

      // Focus the close button
      var closeBtn = panel.querySelector('[data-cart-drawer-close]');
      if (closeBtn) closeBtn.focus();

      // Listen for Escape
      document.addEventListener('keydown', handleKeyDown);

      // Mobile swipe-to-dismiss
      if (isMobile()) {
        panel.addEventListener('touchstart', onTouchStart, { passive: true });
        panel.addEventListener('touchmove', onTouchMove, { passive: true });
        panel.addEventListener('touchend', onTouchEnd, { passive: true });
      }
    }

    // ---- Close ----
    function closeDrawer() {
      if (!isOpen) return;
      isOpen = false;
      panel.setAttribute('aria-hidden', 'true');
      wrapper.classList.remove('c-cart-drawer--open');

      // Unlock body scroll
      document.documentElement.style.overflow = '';

      // Wait for the panel's own slide-out to end before hiding. transitionend
      // bubbles: a child's 150ms hover/focus transition (the close button just
      // tapped) would otherwise set `hidden` mid-slide, and `hidden` now means
      // visibility:hidden, so the panel would vanish instead of sliding out.
      function onTransitionEnd(e) {
        if (e.target !== panel || e.propertyName !== 'transform') return;
        if (!isOpen) {
          panel.setAttribute('hidden', '');
        }
        panel.removeEventListener('transitionend', onTransitionEnd);
      }
      panel.addEventListener('transitionend', onTransitionEnd);

      // Fallback for reduced-motion
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion) {
        panel.setAttribute('hidden', '');
      }

      // Return focus to cart trigger
      if (cartTrigger) cartTrigger.focus();

      document.removeEventListener('keydown', handleKeyDown);

      // Remove swipe listeners
      panel.removeEventListener('touchstart', onTouchStart);
      panel.removeEventListener('touchmove', onTouchMove);
      panel.removeEventListener('touchend', onTouchEnd);
    }

    // ---- Keyboard handler ----
    function handleKeyDown(e) {
      if (e.key === 'Escape') {
        closeDrawer();
        return;
      }
      if (e.key === 'Tab') {
        var focusable = panel.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        if (focusable.length === 0) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    }

    // ---- Refresh via Section Rendering API ----
    function refreshDrawer() {
      body.classList.add('c-cart-drawer__body--loading');

      fetch('/?sections=' + sectionId)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var html = data[sectionId];
          if (!html) return;

          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var newBody = doc.querySelector('[data-cart-drawer-body]');
          if (newBody && body) {
            body.innerHTML = newBody.innerHTML;
          }

          var newDelivery = doc.querySelector('[data-cart-drawer-delivery]');
          if (newDelivery && deliveryBar) {
            deliveryBar.innerHTML = newDelivery.innerHTML;
          }

          var newCount = doc.querySelector('[data-cart-drawer-count]');
          if (newCount && countEl) {
            countEl.textContent = newCount.textContent;
          }

          var newSubtotal = doc.querySelector('[data-cart-drawer-subtotal]');
          if (newSubtotal && subtotalEl) {
            subtotalEl.innerHTML = newSubtotal.innerHTML;
          }

          var newCheckout = doc.querySelector('[data-cart-drawer-checkout]');
          if (newCheckout && checkoutBtn) {
            if (newCheckout.getAttribute('aria-disabled') === 'true') {
              checkoutBtn.setAttribute('aria-disabled', 'true');
              checkoutBtn.setAttribute('tabindex', '-1');
            } else {
              checkoutBtn.removeAttribute('aria-disabled');
              checkoutBtn.removeAttribute('tabindex');
            }
          }

          /* Gelato checkout-block notice: sync text + hidden state so it
             appears/disappears when the offending line is added or removed. */
          var newNotice = doc.querySelector('[data-cart-drawer-checkout-notice]');
          if (newNotice && checkoutNotice) {
            checkoutNotice.innerHTML = newNotice.innerHTML;
            if (newNotice.hasAttribute('hidden')) {
              checkoutNotice.setAttribute('hidden', '');
            } else {
              checkoutNotice.removeAttribute('hidden');
            }
          }

          isStale = false;
          reservedQty = {};
          body.classList.remove('c-cart-drawer__body--loading');

          // Re-apply trash icons after content swap
          updateDecButtons();
        })
        .catch(function () {
          body.classList.remove('c-cart-drawer__body--loading');
        });
    }

    // ---- Quantity change: debounced API call (300ms) ----
    var pendingQtyTimer = null;
    var pendingQtyKey = null;
    var pendingQtyValue = null;
    var pendingQtyMeta = null;

    /* The quantity a press has RESERVED for a line, which is not always what is
       painted: the ceiling pre-flight is asynchronous, so two fast presses would
       otherwise both read the same input value and the second would be lost.
       Cleared whenever the panel re-renders from the server. */
    var reservedQty = {};

    /* Quantity ceilings (B2C-284): the three attributes the shared snippet
       emits on the line article. All three are ABSENT when they do not apply —
       no cap, and no known stock ceiling (which is NOT the same as zero). */
    function ceilingOf(articleEl) {
      if (!articleEl) return {};
      return {
        productId: articleEl.dataset.productId,
        cap: articleEl.dataset.maxQty,
        stock: articleEl.dataset.stock,
        orderLimitMessage: articleEl.dataset.msgOrderLimit
      };
    }

    function flushQuantityChange() {
      if (pendingQtyKey === null) return;
      var lineKey = pendingQtyKey;
      var qty = pendingQtyValue;
      var meta = pendingQtyMeta || {};
      pendingQtyKey = null;
      pendingQtyValue = null;
      pendingQtyMeta = null;

      var api = window.CasinettoCart;
      if (!api || !api.change) { refreshDrawer(); return; }

      /* Every mutation goes through the wrapper — both ceilings live inside it,
         and post-flight turns a clamp or a removal into an explanation instead
         of a silent snap-back. refreshDrawer() runs on every outcome, so the
         panel, the subtotal and the existing live-region announcement stay
         correct whatever came back. */
      api.change({
        key: lineKey,
        quantity: qty,
        productId: meta.productId,
        cap: meta.cap,
        stock: meta.stock,
        orderLimitMessage: meta.orderLimitMessage
      })
        .then(function (result) {
          var cart = result.cart;
          if (cart) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              detail: { data: { itemCount: cart.item_count } }
            }));
          }
          refreshDrawer();
        })
        .catch(function () {
          refreshDrawer();
        });
    }

    function handleQuantityChange(lineKey, newQty, articleEl) {
      /* ---- Optimistic UI update (fires immediately) ---- */
      if (articleEl) {
        var input = articleEl.querySelector('.c-qty input');
        if (input) input.value = newQty;

        if (newQty === 0) {
          articleEl.classList.add('is-removing');
          if (liveRegion) {
            var titleEl = articleEl.querySelector('.c-cart-drawer__item-title');
            var itemName = titleEl ? titleEl.textContent.trim() : 'Item';
            liveRegion.textContent = '';
            requestAnimationFrame(function () {
              liveRegion.textContent = itemName + ' removed from basket';
            });
          }
        }

        updateDecButtons();
      }

      /* ---- Debounced API call (300ms) ---- */
      pendingQtyKey = lineKey;
      pendingQtyValue = newQty;
      pendingQtyMeta = ceilingOf(articleEl);
      clearTimeout(pendingQtyTimer);
      pendingQtyTimer = setTimeout(flushQuantityChange, 300);
    }

    // ---- Event delegation for stepper buttons inside drawer ----
    body.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-action]');
      if (!btn) return;

      var stepper = btn.closest('.c-qty');
      if (!stepper) return;

      var input = stepper.querySelector('input[type="number"]');
      if (!input) return;

      var lineKey = stepper.dataset.lineKey;
      if (!lineKey) return;

      var currentQty = reservedQty[lineKey];
      if (currentQty === undefined) currentQty = parseInt(input.value, 10) || 0;
      var min = parseInt(input.min, 10) || 0;
      var max = parseInt(input.max, 10) || 99;
      var action = btn.dataset.qtyAction;

      var newQty = currentQty;
      if (action === 'inc') {
        newQty = Math.min(currentQty + 1, max);
      } else if (action === 'dec') {
        newQty = Math.max(currentQty - 1, min);
      }

      if (newQty === currentQty) return;

      var articleEl = btn.closest('.c-cart-drawer__item');
      reservedQty[lineKey] = newQty;

      /* A decrease can breach no ceiling, so it keeps the instant optimistic
         path it has always had. */
      if (newQty < currentQty) {
        handleQuantityChange(lineKey, newQty, articleEl);
        return;
      }

      var api = window.CasinettoCart;
      if (!api || !api.check) {
        /* The wrapper still gates the mutation itself; only the no-flicker
           press is lost. Never a reason to skip the change. */
        handleQuantityChange(lineKey, newQty, articleEl);
        return;
      }

      /* THE PRE-FLIGHT RUNS ON THE PRESS, so a refusal never lets the input
         tick up and fall back. The 300ms debounce below is untouched. */
      var meta = ceilingOf(articleEl);
      api.check({
        mode: 'change',
        key: lineKey,
        quantity: newQty,
        productId: meta.productId,
        cap: meta.cap,
        stock: meta.stock,
        orderLimitMessage: meta.orderLimitMessage
      }).then(function (ceiling) {
        if (ceiling) {
          /* Refused. The wrapper fired the toast over the panel; the input was
             never touched, so there is nothing to undo but the reservation. */
          reservedQty[lineKey] = currentQty;
          return;
        }
        handleQuantityChange(lineKey, newQty, articleEl);
      });
    });

    // ---- Close button and overlay clicks ----
    wrapper.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-drawer-close]')) {
        closeDrawer();
        return;
      }
      if (e.target === overlay) {
        closeDrawer();
      }
    });

    // ---- Listen for cart-drawer:open event (from header) ----
    // The shopper asked to see the cart, so this is a view_cart. The hand-over
    // from /cart (openFromUrl, below) opens without it.
    document.addEventListener('cart-drawer:open', function () {
      var wasOpen = isOpen;
      openDrawer();
      if (!wasOpen) emitViewCart();
    });

    // ---- GA4 view_cart (B2C-330) ----
    // Shopify emits cart_viewed, which the Google & YouTube channel sends to GA4
    // as view_cart, only on /cart, and since B2C-326 nobody stays there. So the
    // drawer sends it, through the channel's own gtag: it runs in the top frame
    // (spec-b2c-285 §6.3), and item_id follows its convention so the funnel lines
    // up with its add_to_cart and purchase. Not on the hand-over from /cart, which
    // already emitted cart_viewed; when the hand-over leaves before that hit is
    // sent the view is lost, a rare-path undercount and never a double count.
    // No gtag means no channel (the dev store) or consent denied (Shopify then
    // never loads it): nothing is sent. Nothing here may break the drawer.
    var GA4_MEASUREMENT_ID = 'G-YELSM0205R';
    // The Merchant Center feed's country, NOT Shopify.country: that one follows the
    // visitor's localization (it read "IT" on the dev store, browsing from Italy),
    // while the channel's ids read shopify_AE_ from Italy too (spec-b2c-285 §6.7).
    // The store sells to one market, the UAE.
    var ITEM_ID_COUNTRY = 'AE';

    function emitViewCart() {
      try {
        if (typeof window.gtag !== 'function') return;
        var api = window.CasinettoCart;
        if (!api || !api.fetchCart) return;
        api.fetchCart().then(function (cart) {
          window.gtag('event', 'view_cart', {
            send_to: GA4_MEASUREMENT_ID,
            currency: cart.currency,
            value: cart.total_price / 100,
            items: (cart.items || []).map(function (item) {
              var entry = {
                item_id: 'shopify_' + ITEM_ID_COUNTRY + '_' + item.product_id + '_' + item.variant_id,
                item_name: item.product_title,
                item_brand: item.vendor,
                price: item.final_price / 100,
                quantity: item.quantity
              };
              if (item.variant_title) entry.item_variant = item.variant_title;
              return entry;
            })
          });
        }).catch(function () { /* analytics never breaks the drawer */ });
      } catch (err) { /* analytics never breaks the drawer */ }
    }

    // ---- Mark stale on external cart:update ----
    document.addEventListener('cart:update', function () {
      isStale = true;
      if (isOpen) {
        refreshDrawer();
      }
    });

    // ---- Handle popstate for mobile back-button ----
    window.addEventListener('popstate', function () {
      if (isOpen) {
        closeDrawer();
      }
    });

    // ---- Checkout: waiting state + B2C-214 gate live in assets/checkout-intent.js
    // (B2C-300), keyed on data-checkout-intent. The morph above only re-syncs
    // aria-disabled on the same node, so the module needs no re-binding.

    // ---- The cart page hands over to the drawer (B2C-326) ----
    // Shoppers work in the drawer only. /cart stays a page that works with no
    // JavaScript, because it is where a dead drawer leaves them: the header's
    // cart icon is a real link to /cart. So the hand-over lives HERE, at the end
    // of the drawer's own setup, and runs only once everything above has run.
    // Anything that hid or left /cart before the drawer proved alive (a
    // synchronous redirect, a CSS "js" class) would close the one way to
    // checkout exactly when it is needed. The price is a brief flash of /cart
    // on the rare paths that reach it. Never in the theme editor, or the cart
    // template could not be edited.
    var CART_OPEN_PARAM = 'cart';
    var inEditor = window.Shopify && window.Shopify.designMode;

    if (!inEditor && document.querySelector('[data-cart-page]')) {
      window.location.replace(handOverUrl());
      return;
    }
    openFromUrl();

    // Back to the page the shopper came from when it is ours, otherwise home.
    // Never back to the cart page or checkout: the first would loop, the second
    // is where "back to cart" came from.
    function handOverUrl() {
      var target = new URL('/', window.location.origin);
      try {
        if (document.referrer) {
          var ref = new URL(document.referrer);
          if (ref.origin === window.location.origin && !/^\/(cart|checkouts?)(\/|$)/.test(ref.pathname)) {
            target = ref;
          }
        }
      } catch (err) { /* unreadable referrer: home */ }
      target.searchParams.set(CART_OPEN_PARAM, 'open');
      return target.pathname + target.search + target.hash;
    }

    // ?cart=open: arrived from the cart page. Drop the parameter first, so a
    // reload or a shared link does not open the drawer again, then open.
    function openFromUrl() {
      var url;
      try { url = new URL(window.location.href); } catch (err) { return; }
      if (url.searchParams.get(CART_OPEN_PARAM) !== 'open') return;
      url.searchParams.delete(CART_OPEN_PARAM);
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      openDrawer();
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casinetto-cart"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var textEl = document.querySelector('[data-countdown-text]');
    var dotEl = document.querySelector('[data-cart-countdown-dot]');
    var toEl = document.querySelector('[data-cart-delivering-to]');
    if (!textEl) return;

    function applyPromise(p) {
      textEl.textContent = p.label;

      /* Dot color */
      if (dotEl) {
        dotEl.className = 'c-cart__countdown-dot';
        dotEl.classList.add('c-cart__countdown-dot--' + p.dotColor);
        if (p.dotPulsing) {
          dotEl.classList.add('c-cart__countdown-dot--pulse');
        } else {
          dotEl.classList.add('c-cart__countdown-dot--no-pulse');
        }
      }

      /* Delivering-to line */
      if (toEl) {
        if (p.district && (p.type === 'same-day' || p.type === 'next-day' || p.type === 'future')) {
          toEl.textContent = 'Delivering to ' + p.district;
          toEl.removeAttribute('hidden');
        } else if (p.type === 'no-region') {
          toEl.textContent = 'Set your area for delivery times';
          toEl.removeAttribute('hidden');
        } else {
          toEl.setAttribute('hidden', '');
        }
      }
    }

    /* Register engine callback */
    if (window.CasinettoDelivery) {
      window.CasinettoDelivery.onUpdate(applyPromise);
    } else {
      document.addEventListener('delivery:ready', function () {
        window.CasinettoDelivery.onUpdate(applyPromise);
      });
    }

    /* Delivering-to click → open region selector */
    if (toEl) {
      toEl.addEventListener('click', function () {
        if (window.CasinettoDelivery) window.CasinettoDelivery.openSelector();
      });
    }

    /* No reconcile call here on purpose. cart-sync reconciles on EVERY page
       load now, so an explicit call on the cart page was a straight duplicate —
       two round trips per cart-page load, and the second one re-rendering the
       page under the shopper. The checkout gate in assets/checkout-intent.js
       (B2C-300) still triggers one if none has run. */

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casinetto-header"] && !Shopify.designMode) return;
  try {
    
  // Set --header-height for the casinetto header (theme.liquid looks for header-component which doesn't exist)
  // Also publishes --header-sticky-h (the live height of the sticky #header-group)
  // so elements below the header can position themselves correctly.
  (function () {
    var header = document.querySelector('.c-header');
    var headerGroup = document.getElementById('header-group');
    if (!header || !headerGroup) return;

    function publishHeights() {
      document.body.style.setProperty('--header-height', header.offsetHeight + 'px');
      document.documentElement.style.setProperty('--header-sticky-h', headerGroup.offsetHeight + 'px');
    }

    // -- Delivery-bar placement on breakpoint change --
    // The INITIAL placement is NOT done here. It runs in the inline script right
    // after the header markup, synchronously before first paint — doing it from
    // this deferred block cost 0.478 of desktop CLS (B2C-245). This block only
    // reacts to later breakpoint crossings, reusing that same implementation so
    // there is exactly one copy of the placement logic.
    //
    // The nav row is NOT relocated (B2C-266 Step 6): it stays inside
    // #header-group, collapsed to zero height by CSS ≤900px, so the drawer's
    // <details> keeps a stable displayed ancestor chain and the row
    // contributes 0px to --header-sticky-h automatically.
    var placeDeliveryBar = window.CasinettoHeader && window.CasinettoHeader.placeDeliveryBar;
    var mq = window.matchMedia(
      (window.CasinettoHeader && window.CasinettoHeader.mobileQuery) || '(max-width: 900px)'
    );

    function onBreakpointChange(e) {
      if (placeDeliveryBar) placeDeliveryBar(e.matches);
      // Re-measure after DOM change
      publishHeights();
    }

    // Mobile initial placement happens here rather than in the inline script —
    // see the comment there. On desktop the inline script already did it and
    // flagged initialPlacementDone, so this is a no-op.
    var header_state = window.CasinettoHeader || {};
    if (placeDeliveryBar && !header_state.initialPlacementDone) {
      placeDeliveryBar(mq.matches);
    }

    publishHeights();
    mq.addEventListener('change', onBreakpointChange);
    window.addEventListener('resize', publishHeights, { passive: true });

    // -- Scroll-collapse: hide logo bar on scroll-down, restore on scroll-up --
    var lastScroll = 0;
    var collapseActive = false;

    function onScroll() {
      var current = window.scrollY;
      if (current <= 0) {
        header.classList.remove('c-header--collapsed');
      } else if (current > lastScroll + 10) {
        header.classList.add('c-header--collapsed');
      } else if (current < lastScroll - 5) {
        header.classList.remove('c-header--collapsed');
      }
      // Measure real height after collapse class change
      document.documentElement.style.setProperty('--header-sticky-h', headerGroup.offsetHeight + 'px');
      lastScroll = current;
    }

    var ticking = false;
    function requestTick() {
      if (!ticking && collapseActive) {
        requestAnimationFrame(function () {
          onScroll();
          ticking = false;
        });
        ticking = true;
      }
    }

    function handleCollapseMq(e) {
      collapseActive = e.matches;
      if (!collapseActive) {
        header.classList.remove('c-header--collapsed');
        lastScroll = 0;
      }
      publishHeights();
    }

    handleCollapseMq(mq);
    mq.addEventListener('change', handleCollapseMq);
    window.addEventListener('scroll', requestTick, { passive: true });
  })();

  // Nav drawer glue — single Horizon drawer instance (decisions/header-nav-parity.md (c2)).
  // (a) The mobile hamburger delegates to the drawer's <summary> (hidden ≤900px but
  //     still toggling the details natively) and mirrors the open state on aria-expanded.
  // (b) Focus return on close is OURS: Horizon's removeTrapFocus restores focus to
  //     nothing (decisions F2), so we focus the visible trigger for the current
  //     viewport — hamburger ≤900px, All pill (summary) ≥901px — never a hidden one.
  //     Skipped when focus already moved elsewhere (e.g. the account sheet opened
  //     over the drawer), so we never steal it.
  (function () {
    var drawer = document.querySelector('header-drawer');
    if (!drawer) return;
    var details = drawer.querySelector('details.menu-drawer-container');
    var summary = details ? details.querySelector('summary') : null;
    var hamburger = document.querySelector('[data-drawer-trigger]');
    if (!details || !summary) return;

    var mobileQuery = window.matchMedia('(max-width: 900px)');

    if (hamburger) {
      hamburger.addEventListener('click', function () {
        summary.click();
      });
    }

    // `toggle` does not bubble — this fires for the container details only,
    // never for the nested submenu details.
    details.addEventListener('toggle', function () {
      if (hamburger) {
        if (details.open) {
          hamburger.setAttribute('aria-expanded', 'true');
        } else {
          hamburger.setAttribute('aria-expanded', 'false');
        }
      }
      if (details.open) return;

      // Closed: restore focus only if it was dropped (body) or stranded
      // inside the now-hidden drawer.
      var active = document.activeElement;
      if (active && active !== document.body && !drawer.contains(active)) return;
      if (mobileQuery.matches) {
        if (hamburger) hamburger.focus();
      } else {
        summary.focus();
      }
    });
  })();

  // Inline search dropdown open/close
  (function() {
    var wrap = document.querySelector('[data-search-wrap]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-search-input]');
    var backdrop = wrap.querySelector('[data-search-backdrop]');
    var component = wrap.querySelector('predictive-search-component');
    if (!input) return;

    // The zero-query panel is fetched the first time the panel opens with an
    // empty field, never on page load (B2C-321, D1). The component's method is
    // a no-op once loaded or while a load is in flight. whenDefined covers an
    // early focus: predictive-search.js is a deferred module, and without the
    // wait the panel would stay on its skeleton.
    function loadPanel() {
      if (!component || input.value.trim() || !window.customElements) return;
      customElements.whenDefined('predictive-search-component').then(function() {
        if (input.value.trim()) return;
        if (typeof component.loadEmptyState !== 'function') return;
        // A failed load has already removed the skeleton; the next open retries.
        component.loadEmptyState().catch(function(e) { console.warn('[Search panel]', e); });
      });
    }

    // The single definition of "open": every path that opens the dropdown goes
    // through here, including the empty-submit guard below.
    function openSearch() {
      wrap.classList.add('is-search-open');
      loadPanel();
    }
    function closeSearch() { wrap.classList.remove('is-search-open'); }

    // The predictive-search-component calls .focus() on the input during its
    // upgrade cycle (async, after our script runs — so requestAnimationFrame
    // is too early). Instead we stamp the time of the last real user interaction
    // and reject any focus event that arrives without a recent one.
    var _lastUserAction = 0;
    input.addEventListener('pointerdown', function() { _lastUserAction = Date.now(); });
    document.addEventListener('keydown', function(e) {
      // Tab key navigates focus to the input — treat as intentional
      if (e.key === 'Tab') _lastUserAction = Date.now();
    });

    input.addEventListener('focus', function() {
      if (Date.now() - _lastUserAction > 50) {
        // No recent user interaction → programmatic focus from component → reject
        input.blur();
        return;
      }
      openSearch();
    });

    // Keep dropdown open while typing
    input.addEventListener('input', openSearch);

    // An empty query never leaves the page (B2C-321). Catches the Search
    // button, "View all results" and Enter's native submit. Stamp the user
    // action first, or the focus filter above blurs the input again.
    if (input.form) {
      input.form.addEventListener('submit', function(e) {
        if (input.value.trim()) return;
        e.preventDefault();
        _lastUserAction = Date.now();
        input.focus();
        openSearch();
      });
    }

    if (backdrop) {
      backdrop.addEventListener('mousedown', function(e) {
        e.preventDefault();
        closeSearch();
        input.blur();
      });
    }

    // Close on Escape
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeSearch();
        input.blur();
      }
    });

    // Close when focus moves to a control outside the field and its panel
    // (B2C-329, WCAG 2.4.11): Tab past the panel's last item would otherwise
    // land on controls the open panel covers. Only a move to an element
    // counts. A null relatedTarget is a click on something that takes no
    // focus (Safari's buttons, the panel's padding), a focused add button
    // replaced by its stepper, or the window losing focus: the panel stays.
    // So does a move into what an add from the panel puts above it: a modal
    // (the gelato picker, which returns focus to its trigger in the panel)
    // or the toast (Chrome focuses its dismiss button on click).
    wrap.addEventListener('focusout', function(e) {
      var next = e.relatedTarget;
      if (!next || wrap.contains(next)) return;
      if (next.closest && next.closest('dialog[open], [aria-modal="true"], [data-toast-root]')) return;
      closeSearch();
    });
  })();

  // Account dropdown (desktop) + bottom sheet (mobile)
  (function() {
    var wrap    = document.querySelector('[data-account-wrap]');
    if (!wrap) return;
    var trigger  = wrap.querySelector('[data-account-trigger]');
    var dropdown = wrap.querySelector('[data-account-dropdown]');
    if (!trigger) return;

    // Sheet elements
    var sheet        = document.querySelector('[data-account-sheet]');
    var sheetPanel   = sheet ? sheet.querySelector('[data-account-sheet-panel]') : null;
    var sheetOverlay = sheet ? sheet.querySelector('[data-account-sheet-overlay]') : null;

    var mobileQuery = window.matchMedia('(max-width: 900px)');

    /* --- Desktop dropdown ------------------------------------------------ */
    function isDropdownOpen() {
      return trigger.getAttribute('aria-expanded') === 'true';
    }
    function openDropdown() {
      var searchWrap = document.querySelector('[data-search-wrap]');
      if (searchWrap) searchWrap.classList.remove('is-search-open');
      trigger.setAttribute('aria-expanded', 'true');
      if (dropdown) {
        dropdown.removeAttribute('hidden');
        var first = dropdown.querySelector('[role="menuitem"]');
        if (first) first.focus();
      }
    }
    function closeDropdown() {
      trigger.setAttribute('aria-expanded', 'false');
      if (dropdown) dropdown.setAttribute('hidden', '');
    }

    /* --- Mobile bottom sheet --------------------------------------------- */
    function isSheetOpen() {
      return sheet && sheet.classList.contains('is-open');
    }
    function openSheet() {
      if (!sheet) return;
      // Close other surfaces
      var searchWrap = document.querySelector('[data-search-wrap]');
      if (searchWrap) searchWrap.classList.remove('is-search-open');
      // Nav drawer: public close() on the Horizon component
      // (decisions/header-nav-parity.md (a)); typeof-guarded for the
      // pre-hydration window before the custom element upgrades.
      var navDrawer = document.querySelector('header-drawer');
      if (navDrawer && typeof navDrawer.close === 'function') {
        navDrawer.close();
      }
      closeDropdown();

      sheet.removeAttribute('hidden');
      /* Force reflow so the transition runs */
      sheet.offsetHeight;
      sheet.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      trigger.setAttribute('aria-expanded', 'true');

      var firstLink = sheetPanel ? sheetPanel.querySelector('a') : null;
      if (firstLink) firstLink.focus();
    }
    function closeSheet() {
      if (!sheet) return;
      sheet.classList.remove('is-open');
      document.body.style.overflow = '';
      trigger.setAttribute('aria-expanded', 'false');

      if (sheetPanel) {
        var handler = function() {
          if (!sheet.classList.contains('is-open')) {
            sheet.setAttribute('hidden', '');
          }
          sheetPanel.removeEventListener('transitionend', handler);
        };
        sheetPanel.addEventListener('transitionend', handler);
      } else {
        sheet.setAttribute('hidden', '');
      }
      trigger.focus();
    }

    /* --- Trigger click --------------------------------------------------- */
    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      if (mobileQuery.matches) {
        isSheetOpen() ? closeSheet() : openSheet();
      } else {
        isDropdownOpen() ? closeDropdown() : openDropdown();
      }
    });

    /* --- Close on outside click (dropdown) ------------------------------- */
    document.addEventListener('click', function(e) {
      if (isDropdownOpen() && !wrap.contains(e.target)) closeDropdown();
    });

    /* --- Sheet overlay tap ----------------------------------------------- */
    if (sheetOverlay) {
      sheetOverlay.addEventListener('click', closeSheet);
    }

    /* --- Sheet link clicks close the sheet ------------------------------- */
    if (sheetPanel) {
      var sheetLinks = sheetPanel.querySelectorAll('a');
      for (var i = 0; i < sheetLinks.length; i++) {
        sheetLinks[i].addEventListener('click', function() {
          closeSheet();
        });
      }
    }

    /* --- Escape key ------------------------------------------------------ */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        if (isSheetOpen()) { closeSheet(); return; }
        if (isDropdownOpen()) { closeDropdown(); trigger.focus(); }
      }
    });

    /* --- Arrow-key navigation within the dropdown ------------------------ */
    if (dropdown) {
      dropdown.addEventListener('keydown', function(e) {
        var items = Array.from(dropdown.querySelectorAll('[role="menuitem"]'));
        var idx   = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          items[(idx + 1) % items.length].focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          items[(idx - 1 + items.length) % items.length].focus();
        } else if (e.key === 'Tab') {
          closeDropdown();
        }
      });
    }
  })();

  // Cart icon live update — listens for cart:update (contract: docs/events.md).
  //
  // Payload-carrying emitters (pcard, cart drawer, recipe Add-All, gelato modal,
  // account-orders) send detail.data.itemCount and update synchronously. Emitters
  // that only SIGNAL a change send no count — cart-sync's post-merge and
  // identity-clear events (assets/cart-sync.js) — and for those /cart.js is the
  // contract's source of truth, so re-fetch instead of ignoring the event.
  // Ignoring them left the badge stale until the next navigation: after a
  // cross-device merge it under-reported the cart, and after a logout clear it
  // kept advertising items that no longer existed.
  (function () {
    var _prevCount = null;
    var _seq = 0; // invalidates an in-flight re-fetch when a newer update lands

    function applyCount(count) {
      // --- Header badge ---
      var btn   = document.querySelector('[data-cart-btn]');
      var badge = document.querySelector('[data-cart-count]');
      if (badge) {
        badge.textContent = count;
        if (count > 0) {
          badge.removeAttribute('hidden');
        } else {
          badge.setAttribute('hidden', '');
        }
      }
      if (btn) {
        var tpl = btn.dataset.cartLabelTemplate;
        if (tpl) btn.setAttribute('aria-label', tpl.replace('__COUNT__', count));
      }

      // --- Drawer badge (mobile) ---
      var drawerLink = document.querySelector('[data-cart-drawer-count]');
      if (drawerLink) {
        var drawerTpl = drawerLink.dataset.cartDrawerLabelTemplate;
        if (drawerTpl) drawerLink.textContent = drawerTpl.replace('__COUNT__', count);
      }

      // --- Bounce on increase only ---
      if (_prevCount !== null && count > _prevCount && btn) {
        btn.classList.remove('c-header__cart-btn--bounce');
        // Force reflow so the animation restarts if triggered in rapid succession
        void btn.offsetWidth;
        btn.classList.add('c-header__cart-btn--bounce');
        btn.addEventListener('animationend', function () {
          btn.classList.remove('c-header__cart-btn--bounce');
        }, { once: true });
      }
      _prevCount = count;
    }

    document.addEventListener('cart:update', function (e) {
      var count = e.detail && e.detail.data && e.detail.data.itemCount;
      if (typeof count === 'number') {
        _seq += 1; // a synchronous update supersedes any in-flight re-fetch
        applyCount(count);
        return;
      }

      // No count in the payload: read the cart. Bail if the shared helper is
      // absent — the badge then keeps its server-rendered value, i.e. exactly
      // the previous behaviour, never a wrong one.
      if (!window.CasinettoCart || !window.CasinettoCart.fetchCart) return;

      var ticket = ++_seq;
      window.CasinettoCart.fetchCart()
        .then(function (cart) {
          if (!cart || typeof cart.item_count !== 'number') return;
          if (ticket !== _seq) return; // superseded by a newer update
          applyCount(cart.item_count);
        })
        .catch(function () { /* badge keeps the server-rendered count */ });
    });
  })();

  // Mobile search overlay — open/close + live search
  (function () {
    var pill = document.querySelector('[data-search-pill]');
    var overlay = document.getElementById('search-overlay');
    if (!pill || !overlay) return;
    var input = overlay.querySelector('[data-search-overlay-input]');
    var clearBtn = overlay.querySelector('[data-search-overlay-clear]');
    var emptyState = overlay.querySelector('[data-search-overlay-empty]');
    var liveResults = overlay.querySelector('[data-search-overlay-live]');
    var form = overlay.querySelector('[data-search-overlay-form]');
    var debounceTimer = null;
    var activeFetch = null;

    // Zero-query panel (B2C-321, D1): fetched on the first open, once per page
    // view, from the locale-aware store root so the render context is the same on
    // every page. It replaces the skeleton and stays: resetSearch() only shows and
    // hides its container around typed results, and pcard reconciliation keeps the
    // cards' cart state current, so nothing ever refetches it.
    var panelState = 'idle'; // 'idle' | 'loading' | 'loaded'
    function loadPanel() {
      if (!emptyState || panelState !== 'idle') return;
      panelState = 'loading';
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url = new URL(root, window.location.origin);
      url.searchParams.set('section_id', 'predictive-search-empty');

      fetch(url.toString())
        .then(function (r) {
          if (!r.ok) throw new Error('Search panel request failed: ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var panel = doc.querySelector('[data-search-panel]');
          if (!panel) throw new Error('No search panel in the response');
          // The desktop dropdown owns #predictive-search-results and
          // #predictive-search-products: no element with an id enters the overlay.
          panel.removeAttribute('id');
          panel.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
          // The overlay has no listbox keyboard model, and the rows are plain list
          // items, so Horizon's role="listbox" would be a false role here (axe:
          // aria-required-children, listitem). Plain list semantics instead.
          panel.querySelectorAll('[role="listbox"]').forEach(function (el) { el.removeAttribute('role'); });
          emptyState.innerHTML = '';
          emptyState.appendChild(panel);
          panelState = 'loaded';
        })
        .catch(function (e) {
          // Never leave the skeleton in place; the next open retries.
          panelState = 'idle';
          var skeleton = emptyState.querySelector('[data-search-panel-skeleton]');
          if (skeleton) skeleton.remove();
          console.warn('[Search overlay]', e);
        });
    }

    function openOverlay() {
      overlay.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      pill.setAttribute('aria-expanded', 'true');
      if (input) {
        requestAnimationFrame(function () { input.focus(); });
      }
      loadPanel();
    }
    function closeOverlay() {
      overlay.setAttribute('hidden', '');
      document.body.style.overflow = '';
      pill.setAttribute('aria-expanded', 'false');
      pill.focus();
    }
    function resetSearch() {
      if (input) input.value = '';
      if (clearBtn) clearBtn.hidden = true;
      if (emptyState) emptyState.hidden = false;
      if (liveResults) { liveResults.hidden = true; liveResults.innerHTML = ''; }
    }

    // Open / close
    pill.addEventListener('click', openOverlay);
    overlay.querySelectorAll('[data-search-overlay-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { resetSearch(); closeOverlay(); });
    });
    overlay.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { resetSearch(); closeOverlay(); }
    });

    // Clear button
    if (clearBtn) {
      clearBtn.addEventListener('click', resetSearch);
    }

    // An empty query never leaves the page (B2C-321): the keyboard's Search
    // key submits the form natively. Keep the overlay open and the field focused.
    if (form && input) {
      form.addEventListener('submit', function (e) {
        if (input.value.trim()) return;
        e.preventDefault();
        input.focus();
      });
    }

    // Live predictive search
    if (input && liveResults && emptyState) {
      input.addEventListener('input', function () {
        var q = input.value.trim();
        if (clearBtn) clearBtn.hidden = q.length === 0;
        if (!q) { resetSearch(); return; }

        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () { fetchResults(q); }, 250);
      });
    }

    function fetchResults(query) {
      if (activeFetch) activeFetch.abort();
      var controller = new AbortController();
      activeFetch = controller;

      var url = window.Theme && Theme.routes && Theme.routes.predictive_search_url
        ? Theme.routes.predictive_search_url
        : '/search/suggest';
      var fetchUrl = url + '?q=' + encodeURIComponent(query)
        + '&resources[type]=product&resources[limit]=8&resources[options][fields]=title,product_type,variants.title,vendor'
        + '&section_id=predictive-search';

      fetch(fetchUrl, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cards = doc.querySelectorAll('.predictive-search-results__card--product');
          if (cards.length === 0) {
            liveResults.innerHTML = '<div class="c-search-overlay__no-results"><p>' +
              (window.Theme && Theme.translations && Theme.translations.no_products_found || 'No results found') +
              '</p></div>';
          } else {
            var frag = document.createDocumentFragment();
            cards.forEach(function (card) {
              var link = card.querySelector('a');
              var img = card.querySelector('img');
              var title = card.querySelector('.c-pcard--compact__title');
              var price = card.querySelector('.c-pcard--compact__price');
              var vendor = card.querySelector('.c-pcard--compact__brand');
              if (!link) return;
              var a = document.createElement('a');
              a.href = link.href;
              a.className = 'c-search-overlay__live-result';
              if (img) {
                var i = document.createElement('img');
                i.src = img.src; i.alt = img.alt || '';
                i.width = 48; i.height = 48; i.loading = 'lazy';
                i.className = 'c-search-overlay__live-result-img';
                a.appendChild(i);
              }
              var info = document.createElement('div');
              info.className = 'c-search-overlay__live-result-info';
              if (vendor) {
                var v = document.createElement('span');
                v.className = 'c-search-overlay__live-result-vendor';
                v.textContent = vendor.textContent.trim();
                info.appendChild(v);
              }
              var t = document.createElement('span');
              t.className = 'c-search-overlay__live-result-title';
              t.textContent = title ? title.textContent.trim() : '';
              info.appendChild(t);
              if (price) {
                var p = document.createElement('span');
                p.className = 'c-search-overlay__live-result-price';
                p.textContent = price.textContent.trim();
                info.appendChild(p);
              }
              a.appendChild(info);
              frag.appendChild(a);
            });
            // View all link: the same strict URL as the form paths (B2C-349),
            // locale-aware. Without the helper it keeps the broad URL.
            var viewAll = document.createElement('a');
            viewAll.href = window.CasinettoSearch
              ? window.CasinettoSearch.searchUrl(query)
              : '/search?q=' + encodeURIComponent(query);
            viewAll.className = 'c-search-overlay__live-view-all';
            viewAll.textContent = overlay.dataset.viewAllText || 'View all results';
            frag.appendChild(viewAll);
            liveResults.innerHTML = '';
            liveResults.appendChild(frag);
          }
          emptyState.hidden = true;
          liveResults.hidden = false;
        })
        .catch(function (e) {
          if (e.name !== 'AbortError') console.warn('[Search overlay]', e);
        });
    }
  })();

  // Cart drawer trigger — intercept cart icon click to open drawer
  (function () {
    var cartTrigger = document.querySelector('[data-cart-drawer-trigger]');
    if (cartTrigger) {
      cartTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('cart-drawer:open'));
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casinetto-producers-index"] && !Shopify.designMode) return;
  try {
    
(function() {
  var grid = document.querySelector('[data-producers-grid]');
  if (!grid) return;

  var searchInput = document.querySelector('[data-producers-search]');
  var clearBtn = document.querySelector('[data-producers-search-clear]');
  var emptyEl = document.querySelector('[data-producers-empty]');
  var emptyMsg = document.querySelector('[data-producers-empty-msg]');
  var noResultsTpl = emptyEl ? (emptyEl.dataset.noResultsTpl || '') : '';

  /* Every tile is server-rendered. This only orders what is already here —
     metaobject values come back in creation order, not alphabetically. */
  function sortAllTiles() {
    var tiles = Array.from(grid.querySelectorAll('.c-brand-tile'));
    tiles.sort(function(a, b) {
      var nameA = (a.dataset.producerName || '').toLowerCase();
      var nameB = (b.dataset.producerName || '').toLowerCase();
      return nameA.localeCompare(nameB);
    });
    tiles.forEach(function(t) { grid.appendChild(t); });
  }

  /* ── Search filter ── */
  function normalize(str) {
    return str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  var debounceTimer;
  function onSearch() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(doFilter, 120);
  }

  function doFilter() {
    var q = normalize(searchInput.value.trim());
    if (clearBtn) clearBtn.hidden = !q;

    var tiles = grid.querySelectorAll('.c-brand-tile');
    var visibleCount = 0;
    tiles.forEach(function(tile) {
      var name = normalize(tile.dataset.producerName || '');
      var match = !q || name.indexOf(q) !== -1;
      tile.hidden = !match;
      if (match) visibleCount++;
    });

    /* Empty state */
    if (emptyEl) {
      emptyEl.hidden = visibleCount > 0;
      if (emptyMsg && visibleCount === 0 && q) {
        emptyMsg.textContent = noResultsTpl.replace('__QUERY__', '“' + searchInput.value.trim() + '”');
      }
    }
  }

  function clearSearch() {
    if (searchInput) searchInput.value = '';
    doFilter();
    searchInput.focus();
  }

  /* ── Init ── */
  function init() {
    if (searchInput) searchInput.addEventListener('input', onSearch);
    if (clearBtn) clearBtn.addEventListener('click', clearSearch);
    grid.dispatchEvent(new CustomEvent('producers:loaded', { bubbles: true }));
  }

  function start() {
    sortAllTiles();
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casinetto-product"] && !Shopify.designMode) return;
  try {
    
  // ---- PDP Gallery: mobile dots + desktop thumbnail swap ----
  (function() {
    var galleries = document.querySelectorAll('[data-pdp-gallery]');
    if (!galleries.length) return;

    galleries.forEach(function(gallery) {
      var track = gallery.querySelector('[data-pdp-gallery-track]');
      var items = gallery.querySelectorAll('.c-pdp__gallery-item');
      var dots = gallery.querySelectorAll('.c-pdp__dot');
      var thumbs = gallery.querySelectorAll('.c-pdp__thumb');

      if (!track || items.length < 2) return;

      // --- Mobile: IntersectionObserver on gallery items for dot indicators ---
      var dotObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          var idx = entry.target.dataset.galleryIndex;
          dots.forEach(function(dot) {
            dot.classList.toggle('is-active', dot.dataset.dotIndex === idx);
          });
        });
      }, {
        root: track,
        threshold: 0.5
      });

      items.forEach(function(item) {
        dotObserver.observe(item);
      });

      // Dot click: scroll the carousel to the corresponding item
      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var targetId = this.dataset.dotTarget;
          var targetItem = track.querySelector('[data-media-id="' + targetId + '"]');
          if (targetItem) {
            targetItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        });
      });

      // --- Desktop: thumbnail click swaps the active gallery item ---
      thumbs.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var targetId = this.dataset.thumbTarget;
          // Deactivate all items
          items.forEach(function(item) {
            item.classList.remove('is-active');
          });
          // Deactivate all thumbs
          thumbs.forEach(function(t) {
            t.classList.remove('is-active');
          });
          // Activate target item
          var target = track.querySelector('[data-media-id="' + targetId + '"]');
          if (target) {
            target.classList.add('is-active');
          }
          // Activate clicked thumb
          this.classList.add('is-active');
        });
      });
    });
  })();

  // Share button
  document.querySelectorAll('[data-pdp-share]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var shareData = {
        title: this.dataset.shareTitle,
        url: this.dataset.shareUrl
      };

      if (navigator.share) {
        navigator.share(shareData).catch(function() {});
      } else {
        // Fallback: copy URL to clipboard
        navigator.clipboard.writeText(shareData.url).then(function() {
          var labelEl = btn.querySelector('[data-share-label]');
          var originalText = labelEl.textContent;
          labelEl.textContent = btn.dataset.copiedLabel;
          btn.classList.add('is-copied');
          setTimeout(function() {
            labelEl.textContent = originalText;
            btn.classList.remove('is-copied');
          }, 2000);
        }).catch(function() {});
      }
    });
  });

  // ---- Sticky ATC bar: IntersectionObserver toggle + cross-sync ----
  (function() {
    var stickyBar = document.querySelector('[data-sticky-atc]');
    if (!stickyBar) return;

    var mainAtc = document.querySelector('.c-pdp__cart.c-pcard');
    if (!mainAtc) return;

    var stickyAction = stickyBar.querySelector('.c-pdp__sticky-action');
    if (!stickyAction) return;

    var mainCartDiv = mainAtc.querySelector('.c-pcard__cart');
    var stickyCartDiv = stickyAction.querySelector('.c-pcard__cart');
    if (!mainCartDiv || !stickyCartDiv) return;

    // ---- Visibility: IntersectionObserver on main ATC ----
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-visible');
        } else {
          // Only show sticky bar when main ATC is scrolled above the viewport
          if (entry.boundingClientRect.top < 0) {
            stickyBar.classList.add('is-visible');
          }
        }
      });
    }, {
      threshold: 0
    });

    observer.observe(mainAtc);

    // ---- Cross-sync: keep both ATC areas in the same state ----
    // The pcard JS manages each .c-pcard independently via event delegation.
    // When one transitions (add -> stepper or stepper -> add), the other
    // does not know. We track which side was clicked and sync on cart:update.
    var syncing = false;
    var lastClickedSide = null;

    mainCartDiv.addEventListener('click', function() { lastClickedSide = 'main'; }, true);
    stickyCartDiv.addEventListener('click', function() { lastClickedSide = 'sticky'; }, true);

    document.addEventListener('cart:update', function() {
      if (syncing) return;
      syncing = true;

      var sourceDiv = lastClickedSide === 'sticky' ? stickyCartDiv : mainCartDiv;
      var targetDiv = lastClickedSide === 'sticky' ? mainCartDiv : stickyCartDiv;
      var sourceAction = lastClickedSide === 'sticky' ? stickyAction : mainAtc;
      var targetAction = lastClickedSide === 'sticky' ? mainAtc : stickyAction;

      // Copy DOM from the clicked side to the other
      var sourceHTML = sourceDiv.innerHTML;
      var targetHTML = targetDiv.innerHTML;
      if (sourceHTML !== targetHTML) {
        targetDiv.innerHTML = sourceHTML;
      }

      // Sync line-key
      if (sourceAction.dataset.lineKey) {
        targetAction.dataset.lineKey = sourceAction.dataset.lineKey;
      }

      syncing = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casinetto-recipe-page"]) return;
  try {
    
(function () {
  var triggers = document.querySelectorAll('[data-recipe-add-all]');
  if (!triggers.length) return;

  var controller = new AbortController();
  var signal = controller.signal;
  var statusEl = document.querySelector('[data-recipe-add-status]');
  var stickyBar = document.querySelector('[data-recipe-sticky-addall]');
  var inFlowBtn = null;
  var statusTimer = null;

  /* Locate the in-flow Add-All button (the one inside the aside, not the sticky bar) */
  triggers.forEach(function (btn) {
    if (!stickyBar || !stickyBar.contains(btn)) {
      inFlowBtn = btn;
    }
  });

  /* ---- Quantity ceilings, bulk mode (B2C-284) -------------------------
     Add-All adds EVERYTHING IT CAN and reports afterwards, so it makes ONE
     CasinettoCart.addMany() call and emits ONE aggregated toast from the
     index-aligned `ceilings` it gets back. addMany fires no toast itself and
     takes no `silent` — a dozen ingredients cannot produce a sensible single
     message, so composing it is this surface's job
     (decisions/quantity-ceilings-structure.md D14 §4).

     One call, not one per ingredient: per-item add() made a 10-ingredient
     Add-All ~20 sequential round trips, twenty failure points and ten
     cart:update passes over every card on the page (D14).

     It deliberately does NOT call check() first, per ingredient or at all:
     check() is for a surface that paints a quantity before the mutation
     returns, this one paints nothing, and the allocation inside addMany IS the
     pre-flight (D14 §5).

     The per-item ceiling values are read off the .c-pcard the grid already
     renders for that variant — snippets/quantity-ceiling-attrs.liquid emits
     them there, and the rule must not exist twice on one page. A missing card
     simply means no ceiling is known up front; post-flight still catches it. */
  var MAX_NAMED = 2;         /* the toast names at most two blocked items */
  var RECIPE_REQUIRES = 1;   /* Add-All asks for one unit of each ingredient */

  function copyBag() {
    return (statusEl && statusEl.dataset) || {};
  }

  function fill(template, count) {
    if (!template) return '';
    return template.split('__COUNT__').join(String(count));
  }

  function reasonText(ceiling) {
    var bag = copyBag();
    if (ceiling.reason === 'ORDER_LIMIT') return fill(bag.bulkMsgOrderLimit, ceiling.limit);
    if (ceiling.reason === 'SOLD_OUT_ADD') return bag.bulkMsgSoldOutAdd || '';
    return fill(bag.bulkMsgStockBlocked, ceiling.limit);
  }

  function parseIds(btn) {
    var raw = btn.getAttribute('data-recipe-add-all') || '';
    var seen = {};
    return raw.split(',').reduce(function (acc, part) {
      var id = part.trim();
      /* Digits only: the id goes straight into an attribute selector below, and
         a malformed metaobject value must not throw a SyntaxError that takes
         the whole handler down with it. */
      if (!/^[0-9]+$/.test(id) || seen[id]) return acc;
      seen[id] = true;
      var card = document.querySelector('.c-recipe__grid .c-pcard[data-variant-id="' + id + '"]');
      var d = (card && card.dataset) || {};
      acc.push({
        id: parseInt(id, 10),
        quantity: RECIPE_REQUIRES,
        productId: d.productId,
        title: d.productTitle || '',
        cap: d.maxQty,
        stock: d.stock
      });
      return acc;
    }, []);
  }

  /* An ingredient is "short" when, once everything that could be added has
     been, the cart holds less of that product than the recipe asks for. A
     capped product the shopper already holds at the cap is NOT short — the
     recipe only needs one — so the sentence fires on a genuine gap, never on a
     refusal that left enough behind. */
  function anyIngredientShort(blocked, cart) {
    if (!blocked.length || !cart) return false;
    if (!window.CasinettoCart || !window.CasinettoCart.buildProductMap) return true;
    var map = window.CasinettoCart.buildProductMap(cart);
    for (var i = 0; i < blocked.length; i++) {
      var entry = blocked[i].productId ? map[String(blocked[i].productId)] : null;
      if (!entry || entry.qty < RECIPE_REQUIRES) return true;
    }
    return false;
  }

  function announceBlocked(blocked, cart) {
    if (!window.CasinettoToast || !blocked.length) return;
    var bag = copyBag();
    var lines = [];
    var critical = false;
    var i;

    for (i = 0; i < blocked.length && i < MAX_NAMED; i++) {
      lines.push({ title: blocked[i].title, text: reasonText(blocked[i].ceiling) });
    }
    if (blocked.length > MAX_NAMED) {
      lines.push(fill(bag.bulkMsgMore, blocked.length - MAX_NAMED));
    }
    for (i = 0; i < blocked.length; i++) {
      if (blocked[i].ceiling.reason === 'ORDER_LIMIT') { critical = true; break; }
    }
    /* A recipe missing an ingredient is a different failure from a cart missing
       an item, so the recipe page says so on top of the per-item reasons. */
    if (anyIngredientShort(blocked, cart) && bag.bulkMsgRecipeShort) {
      lines.push(bag.bulkMsgRecipeShort);
    }

    window.CasinettoToast.show({
      variant: critical ? 'critical' : 'info',
      message: bag.bulkMsgSummary || '',
      lines: lines
    });
  }

  function setBusy(isBusy) {
    triggers.forEach(function (btn) {
      if (isBusy) {
        btn.dataset.state = 'busy';
      } else {
        delete btn.dataset.state;
      }
    });
  }

  function showStatus(message, isError) {
    if (!statusEl) return;
    statusEl.textContent = message;
    if (isError) {
      statusEl.setAttribute('data-error', 'true');
    } else {
      statusEl.removeAttribute('data-error');
    }
    if (statusTimer) clearTimeout(statusTimer);
    statusTimer = setTimeout(function () {
      statusEl.textContent = '';
      statusEl.removeAttribute('data-error');
    }, 4000);
  }

  function emitCartUpdate(itemCount) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { data: { itemCount: itemCount, source: 'recipe-add-all' } }
    }));
  }

  function onClick(event) {
    var btn = event.currentTarget;
    if (btn.dataset.state === 'busy') return;

    var items = parseIds(btn);
    if (!items.length) return;

    /* Every cart mutation goes through the wrapper. If it has not loaded,
       stand down rather than reopening a second, ungated add path. */
    var api = window.CasinettoCart && window.CasinettoCart.addMany ? window.CasinettoCart : null;
    if (!api) {
      showStatus(statusEl && statusEl.dataset.errorTpl ? statusEl.dataset.errorTpl : '', true);
      return;
    }

    setBusy(true);

    /* ONE call for the whole basket. The allocation inside addMany is
       cumulative, so two ingredients sharing a product draw on one cap ledger
       and the second sees what the first took — which is exactly what N
       parallel per-item adds could not do, and what N sequential ones paid ~20
       round trips for. */
    api.addMany(items)
      .then(function (result) {
        if (signal.aborted) return;

        /* `ceilings` is index-aligned to `items`; `result.items` is the raw
           /cart/add.js response and is NOT — never pair them. The product
           title lives here, at the call site, which is why the pairing is
           this surface's job. */
        var blocked = [];
        for (var i = 0; i < items.length; i++) {
          if (result.ceilings[i]) {
            blocked.push({
              title: items[i].title,
              productId: items[i].productId,
              ceiling: result.ceilings[i]
            });
          }
        }

        /* One cart:update for the whole press, as it was before ceilings —
           not one per ingredient. */
        if (result.items.length) {
          emitCartUpdate(
            result.cart && typeof result.cart.item_count === 'number' ? result.cart.item_count : undefined
          );
        }

        if (blocked.length) {
          /* The toast carries the whole story, and the baked confirm count
             ("N ingredients added") would be wrong here. */
          announceBlocked(blocked, result.cart);
          return;
        }
        if (!result.items.length) {
          /* Nothing landed and nothing was refused at a ceiling: the batch was
             turned down for a reason we cannot attribute to an ingredient. */
          showStatus(statusEl && statusEl.dataset.errorTpl ? statusEl.dataset.errorTpl : '', true);
          return;
        }
        // The confirm template is rendered server-side with the resolved
        // plural + count baked in (data-confirm-tpl), so it is shown verbatim.
        showStatus(statusEl && statusEl.dataset.confirmTpl ? statusEl.dataset.confirmTpl : '', false);
      })
      .catch(function () {
        if (signal.aborted) return;
        showStatus(statusEl && statusEl.dataset.errorTpl ? statusEl.dataset.errorTpl : '', true);
      })
      .finally(function () {
        setBusy(false);
      });
  }

  triggers.forEach(function (btn) {
    btn.addEventListener('click', onClick, { signal: signal });
  });

  /* ── Mobile sticky bar visibility (IntersectionObserver on in-flow button) ── */
  var observer = null;
  if (stickyBar && inFlowBtn && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-visible');
        } else if (entry.boundingClientRect.top < 0) {
          stickyBar.classList.add('is-visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(inFlowBtn);
  }

  /* ── Share / print actions ── */
  var shareBtn = document.querySelector('[data-recipe-share-native]');
  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      var url = window.location.href;
      var title = document.title;
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          shareBtn.classList.add('is-copied');
          setTimeout(function () { shareBtn.classList.remove('is-copied'); }, 2000);
        }).catch(function () {});
      }
    }, { signal: signal });
  }

  var printBtn = document.querySelector('[data-recipe-print]');
  if (printBtn) {
    printBtn.addEventListener('click', function () { window.print(); }, { signal: signal });
  }

  /* ── Teardown ── */
  window.addEventListener('pagehide', function () {
    controller.abort();
    if (observer) observer.disconnect();
    if (statusTimer) clearTimeout(statusTimer);
  }, { once: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casinetto-recipes-index"] && !Shopify.designMode) return;
  try {
    
(function () {
  var grid = document.querySelector('[data-recipes-grid]');
  if (!grid) return;

  var emptyEl = document.querySelector('[data-recipes-empty]');
  var countEl = document.querySelector('[data-recipes-count]');
  var filters = document.querySelectorAll('[data-recipe-filter]');
  var countTpl = countEl ? countEl.textContent : '';

  var activeCategory = '';

  /* ── Filter ── Every card is server-rendered; this only hides and shows. */
  function applyFilter() {
    var cards = grid.querySelectorAll('.c-recipe-card');
    var visible = 0;
    cards.forEach(function (card) {
      var cats = card.dataset.categories || '';
      var match = !activeCategory || cats.indexOf(activeCategory) !== -1;
      card.hidden = !match;
      if (match) visible++;
    });

    if (countEl && countTpl) {
      countEl.textContent = countTpl.replace(/\d[\d,]*/, String(visible));
    }
    if (emptyEl) emptyEl.hidden = visible > 0;
  }

  function onFilterClick(event) {
    var btn = event.currentTarget;
    activeCategory = (btn.dataset.recipeFilter || '').toLowerCase();
    filters.forEach(function (f) {
      f.setAttribute('aria-pressed', f === btn ? 'true' : 'false');
    });
    applyFilter();
  }

  /* ── Init ── */
  function init() {
    filters.forEach(function (btn) {
      btn.addEventListener('click', onFilterClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casinetto-search-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    if (window.Shopify && window.Shopify.designMode) return;

    function fallBack() {
      if (!document.querySelector('[data-search-fallback]')) return;

      var url = new URL(window.location.href);
      var q = url.searchParams.get('q');
      if (!q || q.indexOf('"') === -1) return;

      url.searchParams.set('q', q.replace(/"/g, '').replace(/\s+/g, ' ').trim());
      url.searchParams.delete('page');
      window.location.replace(url.toString());
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fallBack, { once: true });
    } else {
      fallBack();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-account-shell"]) return;
  try {
    
  /* Account shell — prefetch + navigation transition
     ----------------------------------------------------------------
     1. Idle-prefetch: after page settles, prefetch the other account
        page so clicking the nav link hits browser cache.
     2. Hover-prefetch: if idle prefetch hasn't fired yet, a hover
        on a nav link triggers it immediately.
     3. Click transition: fade the content area out on click so the
        user gets instant visual feedback while the page loads.
  */
  (function () {
    var ACCOUNT_PAGES = ['/pages/my-account', '/pages/my-orders', '/pages/my-buy-again'];
    var currentPath = window.location.pathname.replace(/\/$/, '');
    var prefetched = {};

    /* ---- Prefetch helper ------------------------------------------------ */
    function prefetchPage(href) {
      if (prefetched[href]) return;
      prefetched[href] = true;
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      link.as = 'document';
      document.head.appendChild(link);
    }

    /* ---- 1. Idle prefetch the other page -------------------------------- */
    var otherPages = ACCOUNT_PAGES.filter(function (p) { return p !== currentPath; });
    var idleCb = typeof requestIdleCallback === 'function' ? requestIdleCallback : function (fn) { setTimeout(fn, 2000); };
    otherPages.forEach(function (page) {
      idleCb(function () { prefetchPage(page); });
    });

    /* ---- 2. Hover prefetch on nav links --------------------------------- */
    document.addEventListener('pointerenter', function (e) {
      var link = e.target.closest && e.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (ACCOUNT_PAGES.indexOf(href) !== -1 && href !== currentPath) {
        prefetchPage(href);
      }
    }, true);

    /* ---- 3. Click transition: fade content ------------------------------ */
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (ACCOUNT_PAGES.indexOf(href) === -1 || href === currentPath) return;
      /* Don't intercept modifier-clicks (new tab, etc.) */
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;

      var content = document.querySelector('.c-account-shell__content');
      if (content) {
        content.style.transition = 'opacity 0.15s ease-out';
        content.style.opacity = '0.4';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deal-of-the-week"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    document.querySelectorAll('[data-deal-wrap]').forEach(function (wrap) {
      var rail    = wrap.querySelector('[data-deal-rail]');
      var prevBtn = wrap.querySelector('[data-deal-prev]');
      var nextBtn = wrap.querySelector('[data-deal-next]');
      if (!rail || !prevBtn || !nextBtn) return;

      var isRtl = document.documentElement.dir === 'rtl';

      function updateButtons() {
        var canScroll = rail.scrollWidth > rail.clientWidth + 2;
        wrap.classList.toggle('has-overflow', canScroll);

        if (isRtl) {
          prevBtn.disabled = Math.abs(rail.scrollLeft) <= 4;
          nextBtn.disabled = Math.abs(rail.scrollLeft) >= rail.scrollWidth - rail.clientWidth - 4;
        } else {
          prevBtn.disabled = rail.scrollLeft <= 4;
          nextBtn.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 4;
        }
      }

      function scrollByCard(direction) {
        var card = rail.querySelector('.c-deal-section__product-item');
        var gap  = parseInt(getComputedStyle(rail).gap) || 0;
        var amount = card ? card.offsetWidth + gap : rail.clientWidth * 0.5;
        rail.scrollBy({ left: (isRtl ? -direction : direction) * amount, behavior: 'smooth' });
      }

      prevBtn.addEventListener('click', function () { scrollByCard(-1); });
      nextBtn.addEventListener('click', function () { scrollByCard(1); });
      rail.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons, { passive: true });

      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
